import { render, staticRenderFns } from "./SiteCopy.vue?vue&type=template&id=7153d5da&scoped=true&"
import script from "./SiteCopy.vue?vue&type=script&lang=js&"
export * from "./SiteCopy.vue?vue&type=script&lang=js&"
import style0 from "./SiteCopy.vue?vue&type=style&index=0&id=7153d5da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153d5da",
  null
  
)

export default component.exports